import { createZodDto } from 'nestjs-zod/dto';
import { z } from 'zod';
export const SsoLoginParamsResponseSchema = z.object({
    clientId: z.string(),
    openIdConnectUrl: z.string(),
});
export class SsoLoginParamsResponseDto extends createZodDto(SsoLoginParamsResponseSchema) {
}
